import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {FormModel} from "../form/form.model.abstract";
import {InfoService} from "../services/info.service";
import {EmbedService} from "../services/embed.service";
import {BackendService} from "../services/backend.service";

@Component({
  selector: 'app-info-callout',
  templateUrl: './formfield.info.callout.component.html'
})
export class FormfieldInfoCalloutComponent implements OnInit {
  /**
   * The configuration for this formfield
   */
  @Input() formModel: FormModel;

  /**
   * toggle for showing/hiding the help element
   */
  @Input() show: boolean = false;

  /**
   * Extra postfix for the textkey.
   */
  @Input() fieldNamePostfix: string = "";

  /**
   * Holds the current advisor
   */
  advisor: string;

  /**
   * id of the html element
   */
  id: string;

  /**
   * constructor
   * @param element
   * @param backenService
   * @param infoService
   * @param embedService
   */
  constructor(private element: ElementRef, private backenService: BackendService, private infoService: InfoService, private embedService: EmbedService) {
    // get the current advisor
    this.advisor = this.backenService.getAdvisor();
  }

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // add underscore to postfixtextfeild to have more beautiful textkeys
    if(this.fieldNamePostfix) {
      this.fieldNamePostfix = '_' + this.fieldNamePostfix;
    }

    // set id and init the width
    this.id = this.formModel.id;
    if(this.formModel.idPostfix) {
      this.id = this.id.replace(new RegExp(this.formModel.idPostfix + "$"), "");
    }
    this.id += this.fieldNamePostfix + '_info';
  }

}
